module.exports = __webpack_public_path__ + "img/zhongying.9de3c0de.png";